<template>
  <div>
    <v-btn absolute dark fab top right color="primary" style="top:10px;" @click="bankDialog = true">
      <v-icon color="black">add</v-icon>
    </v-btn>
    <bankForm
      :dialog="bankDialog"
      @setDialog="bankDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :select_item="select_item"
    />
    <v-data-table
      :loading="fetching_data"
      :headers="headers"
      :items="weserve_bank"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ weserve_bank.indexOf(props.item)+1 }}</td>
        <td class="text-xs-center">{{ props.item.bank_name }}</td>
        <td class="text-xs-center">{{ props.item.bank_account_number }}</td>
        <td class="text-xs-center">{{ props.item.bank_account_name }}</td>
        <td class="text-xs-center">{{ filterBankStatus(props.item) }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top v-if="!isEditRiderSetting">
            <v-btn icon @click="editBankDetail(props.item)" slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <v-btn
              icon
              :loading="deleting_index == props.index"
              :disabled="deleting_index == props.index"
              slot="activator"
              @click="delBankAccount(props.item,props.index)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>-->
          <v-switch
            v-if="!isEditRiderSetting"
            v-model="props.item.bank_status"
            @change="changStatus(props.item)"
            color="primary"
            style="max-width:50px;margin-top:12px;"
            :disabled="props.item.bank_status == false ? checkDupBank(props.item) : false"
          ></v-switch>
        </td>
      </template>

      <template slot="no-data" class="text-xs-center">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import bankForm from "./BankForm";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    deleting_index: -1,
    fetching_data: false,
    select_item: {},
    bankDialog: false,
    editedIndex: -1,
    dialog: false,
    pagination: {
      rowsPerPage: 5
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "num"
      },
      {
        text: "Bank name",
        align: "center",
        value: "bank_name",
        sortable: true
      },
      {
        text: "Bank No.",
        align: "center",
        value: "bank_name",
        sortable: false
      },
      {
        text: "Account name",
        align: "center",
        value: "account_name",
        sortable: false
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false
      },
      {
        text: "Action",
        align: "center",
        value: "action",
        sortable: false
      }
    ]
  }),
  components: {
    bankForm
  },
  props: {
    weserve_bank: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["isEditRiderSetting"]),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    checkDupBank(item) {
      let check = 0;
      for (let val of this.weserve_bank) {
        if (val.bank_name_id == item.bank_name_id && val.bank_status == true) {
          check = 1;
          break;
        }
      }
      if (check == 1) {
        return true;
      } else {
        return false;
      }
    },
    async delBankAccount(item, index) {
      this.deleting_index = index;
      (await confirm("Do you want to delete ?")) &&
        (await this.$store.dispatch(
          "fetchWeserveBank/delBankAccount",
          item.bank_id
        ));
      this.deleting_index = -1;
    },
    filterBankStatus(item) {
      if (item.bank_status == 1) {
        item.bank_status_name_temp = "Active";
      } else {
        item.bank_status_name_temp = "Inactive";
      }
      return item.bank_status_name_temp;
    },
    async initialize() {
      this.fetching_data = true;
      await this.$store.dispatch("fetchWeserveBank/getWeserveBank");
      this.fetching_data = false;
    },
    editBankDetail(item) {
      this.select_item = item;
      this.bankDialog = true;
      this.editedIndex = 1;
    },
    async changStatus(item) {
      let check = await this.$store.dispatch(
        "fetchWeserveBank/changeStatusBank",
        {
          bank_id: item.bank_id,
          bank_status: item.bank_status
        }
      );
      if (check == 3) {
        item.bank_status = !item.bank_status;
      }
    }
  }
};
</script>

